"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.project.exceeded': '已达到项目限制。升级您的计划以创建更多项目。',
    'limits.project.limitReached': '项目限制：{limit}（升级以创建更多）',
};
